import React from 'react';

/**
 * WarningIcon - holito brand-tier icon (2px stroke, 24 grid, the notch where applicable).
 * Geometry from the brand guide (docs/DESIGN.md section 08 / Iconography).
 */
export const WarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 4 L20 20 H4 Z" />
    <path d="M12 9 V14" />
    <path d="M12 17 h0" />
  </svg>
);
